<template>
  <div>
    <el-dialog
      title=""
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :show-close="false"
      width="400px"
      class="preivew-dialog"
      :before-close="handleClose"
    >
      <div v-loading="dialogVisible">
        <div ref="paintEl" class="pic">
          <img :src="qrCode" crossOrigin='anonymous' style="width: 100%; height: 100%">
          <img id="imgLogo" :src="logoUrl" crossOrigin='anonymous' class="qr-logo">
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import oss from '@/api/base/api-upload'
import { updateCodeUrl } from '@/api/admin/saleQrcode.js'
import html2canvas from 'html2canvas'

export default {
  name: 'PaintQrcode',

  data () {
    return {
      id: null,
      dialogVisible: false,
      qrCode: '',
      logoUrl: ''
    }
  },
  methods: {
    init ({ id, qrCode, logoUrl }) {
      this.id = id
      this.qrCode = qrCode
      this.logoUrl = logoUrl
      this.dialogVisible = true
      this.$nextTick(() => {
        this.paint()
      })
    },
    paint () {
      const img1 = document.getElementById('imgLogo')
      img1.onload = () => {
        html2canvas(this.$refs.paintEl, {
          useCORS: true
        }).then((canvas) => {
          var fileImage = this.blobToFile(this.dataURLtoBlob(canvas.toDataURL()))
          this.uploadImg(fileImage)
        })
      }
    },
    uploadImg (fileImage) {
      oss(fileImage, 0, 'wap/saleQrcode/').then(codeUrl => {
        updateCodeUrl({ id: this.id, codeUrl }).then(({ code }) => {
          if (code === 0) {
            this.$message.success('生成二维码成功!')
            this.$emit('close')
            this.handleClose()
          }
        })
      })
    },
    dataURLtoBlob (dataurl) {
      let arr = dataurl.split(',')
      let mime = arr[0].match(/:(.*?);/)[1]
      let bstr = atob(arr[1])
      let n = bstr.length
      let u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], { type: mime })
    },
    blobToFile (theBlob) {
      theBlob.lastModifiedDate = new Date()
      theBlob.name = this.randomString(10) + 's.png'
      return theBlob
    },
    // 生成随机字符串
    randomString (len) {
      len = len || 32
      var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
      var maxPos = chars.length
      var pwd = ''
      for (let i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos))
      }
      return pwd
    },
    handleClose () {
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.pic {
  display: inline-block;
  width: 100%;
  height: auto;
  margin: 0;
  border-radius: 4px;
  position: relative;
  overflow: hidden;
  .qr-logo {
    width: 88px;
    height: 88px;
    border-radius: 16px;
    border: 6px solid #FFFFFF;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -52%);
  }
}
.preivew-dialog {
  ::v-deep .el-dialog__body,
  ::v-deep .el-dialog__header {
    padding: 0;
  }
}
</style>
